import React, { useState } from "react"
import PropTypes from "prop-types"

import L10n from "../../../lib/carrot-l10n"

import { useDidMount } from "../../../utils/Hooks"
import { Body } from "../atoms/Bodies"
import { Spacer } from "../atoms/Atoms"
import { MerchantDeclineLoading } from "./MerchantDeclineLoading"
import CarrotClient from "lib/carrot-api/index"
import Settings from "../../../utils/CarrotConfig"
import { useHistory, useParams } from "react-router-dom"
import { H2 } from "@carrotfertility/carotene"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const defaultState = {
  isLoading: true
}

export const MerchantApproved = () => {
  const { token } = useParams()
  const [state, setState] = useState(defaultState)
  const history = useHistory()

  useDidMount(() => {
    const approveMerchant = async () => {
      try {
        await client.approveMerchant(token)
        setState({
          ...state,
          isLoading: false
        })
      } catch {
        history.push("/confirm/error")
      }
    }

    approveMerchant().then()
  })
  return state.isLoading ? (
    <MerchantDeclineLoading />
  ) : (
    <>
      <Spacer height={2} />
      <H2 variant="dark">{l`Thanks for confirming`}</H2>
      <Spacer height={1} />
      <Body>{l`Your Carrot Card should now work with this provider — please try again.`}</Body>
    </>
  )
}

MerchantApproved.propTypes = {
  token: PropTypes.string
}
